<template src="./DataDetails.html"></template>
<style src="./DataDetails.css"></style>

<script>
import moment from "moment";

import store from "@/store/index";

export default {
  props: ["COMVALID"],
  data() {
    return {
      pagination: { rowsPerPage: 100 },
      detailsHeaders: [
      {
          text: "Cliente",
          value: "CLINOME"
        },
        {
          text: "CNPJ",
          value: "CLICNPJ"
        },
        {
          text: "IE",
          value: "CLIIE"
        },
        {
          text: "Data último",
          value: "lastDate"
        },
        /*{
          text: "Com erros",
          value: "withError"
        },
        {
          text: "Sem retornos",
          value: "nonReturn"
        },
        {
          text: "Com retornos",
          value: "withReturn"
        },*/
        {
          text: "Total",
          value: "total"
        },
        {
          text: "Versão",
          value: "COMVALLOGVERSAOSISTEMA"
        }
      ]
    };
  },
  methods: {
    lastDate(_lastDate) {
      return moment(_lastDate).format("DD/MM/YYYY");
    }
  },
  computed: {
    isXs() {
      return store.state.window.isXs;
    },
    details() {
      var dataDetails = [];

      store.state.comandosValidacaoLog.dataDetails.forEach(details => {
        if (details.length > 0)
          if (details[0].COMVALID == this.COMVALID) dataDetails = details;
      });
      return dataDetails;
    },
    loadingDataDetails() {
      return store.state.comandosValidacaoLog.loadingDataDetails;
    }
  }
};
</script>

